import { Component, Inject, OnInit } from '@angular/core';
import { areEqual, deepCopy, DwActionPreference, DwComponent, DwComponentType, DwFormActionConfig, DwFormActionInterceptor, DwFormActionInterceptResult, DwFormActionKeys, DwFormContextMode, DwFormValidationResult, DwLookupInfo, DwLookupSearchParams, DwLookupSearchType, DwMdFormContextInfo, DwMetaDataFormApi, DwMetaDataFormStateService, DwMetaDataService, DwMetaDataServiceToken, DwQueryParam, getParameterByName } from '@devwareapps/devware-cap';
import { AirportWithAddressInfoQueryEntity, AppMetaData, AppMetaDataItemNames, AppMetaDataLookups, CheckRideOwnershipTypeAllItems, PilotExaminerAirportListQueryEntity, PilotExaminerFlightSchoolSetupEntity, PilotExaminerLocationEntity, PilotExaminerLocationTypeAllItems, ScheduleBlockEntity, ScheduleBlockItemEntity, ScheduleBlockItemStatusAllItems, ScheduleBlockItemTypeAllItems, UserTypeAllItems } from '../../../../meta-data/app-meta-data.service';
import { AdminManagerService } from '../../../shared/services/admin-manager.service';
import { Router } from '@angular/router';
import { DateTimeUtilService } from '../../../shared/util/date-time-util.service';
import { ScheduleBlockService } from '../../services/schedule-block.service';
import { ScheduleBlockDateRef } from '../../models/schedule-block-date-ref.model';
import { ExaminerRepositoryService } from '../../../examiner/services/examiner-repository.service';
import { combineLatest, Observable, of } from 'rxjs';
import { PilexosUserTypeIds } from '../../../shared/models/pilexos-user-type.enum';
import { AirportLookupDetails } from '../../models/airport-lookup-details.model';
import { map, tap } from 'rxjs/operators';
import { PilexosUser } from '../../../shared/models/pilexos-user.model';
import { ScheduleBlockSchoolExaminerOptions } from '../../models/schedule-block-school-examiner-options.model';


@DwComponent({
  key: 'examiner-block-booking-item-create-section',
  name: 'Examiner Block Booking Item Create',
  componentType: DwComponentType.formSection,
  isGlobal: false,
  parentItemName: AppMetaDataItemNames.ScheduleBlock,
})
@Component({
  selector: 'app-examiner-block-booking-item-create',
  templateUrl: './examiner-block-booking-item-create.component.html',
  styleUrls: ['./examiner-block-booking-item-create.component.scss']
})
export class ExaminerBlockBookingItemCreateComponent implements OnInit {
  blockItemTypeLookupId = AppMetaDataLookups.ScheduleBlockItemTypeAllItems;
  scheduleLookupId = AppMetaDataLookups.SchedulesByUser;

  scheduleParams: any;

  bookingScheduleId: number;
  blockItemTypeId: number = ScheduleBlockItemTypeAllItems.IndividualDay;

  BlockItemTypes = ScheduleBlockItemTypeAllItems;
  startTime: string = '08:00';
  endTime: string = '17:00';

  selectedDates: string = '';
  startDate: string;
  endDate: string;
  formApi: DwMetaDataFormApi;

  scheduleLookupParams: any[] = [];
  locations: PilotExaminerLocationEntity[];
  scheduleBlockItem: ScheduleBlockItemEntity;
  flightSchoolSetup: PilotExaminerFlightSchoolSetupEntity[];
  currentSchoolSetup: PilotExaminerFlightSchoolSetupEntity;
  hasBlocks: boolean;
  airportLookupItems: AirportLookupDetails[];
  lastAirportId: number;
  pilexosUser: PilexosUser;
  schoolExaminerOptions: ScheduleBlockSchoolExaminerOptions[];
  schoolExaminer: DwLookupInfo[];
  referenceDataLoadComplete: boolean;
  isAdd: boolean;
  lastScheduleBlock: ScheduleBlockEntity;
  canAddEdit: boolean;
  canAddEditReason: string;
  currentAirports: AirportWithAddressInfoQueryEntity[] = [];
  showDateSelection: boolean = true;
  airportLocationValidationResults: { errors: string[]; warnings: string[]; errorMessage: string, warningMessage: string } = {
    errors: [],
    warnings: [],
    errorMessage: '',
    warningMessage: ''
  };

  currentAirportDetails: AirportWithAddressInfoQueryEntity[] = [];
  examinerAirportList: PilotExaminerAirportListQueryEntity[];

  constructor(
    private dwMetaDataFormStateService: DwMetaDataFormStateService,
    protected adminManagerService: AdminManagerService,
    private dateTimeUtilService: DateTimeUtilService,
    private scheduleBlockService: ScheduleBlockService,
    private examinerRepositoryService: ExaminerRepositoryService,
    @Inject(DwMetaDataServiceToken) private dwMetaDataManagerService: DwMetaDataService,
    private router: Router) {

    this.formApi = this.dwMetaDataFormStateService.state.formApi;
  }

  scheduleBlock: ScheduleBlockEntity;
  initComplete = false;

  ownershipTypeId: number = CheckRideOwnershipTypeAllItems.Examiner;

  isSchool: boolean = false;
  isExaminer: boolean = true;

  ngOnInit(): void {

    this.pilexosUser = this.adminManagerService.getPilexosUser();

    const schoolUserTypes = [PilexosUserTypeIds.flightSchool, PilexosUserTypeIds.checkInstructor];

    this.isSchool = schoolUserTypes.includes(this.pilexosUser.UserTypeId);
    this.isExaminer = this.pilexosUser.UserTypeId === PilexosUserTypeIds.pilotExaminer;

    this.setupFormInterceptor();
    this.scheduleBlock = this.formApi.getFormData<ScheduleBlockEntity>();

    this.setupReferenceData();

    this.formApi.getFormDataChanges<ScheduleBlockEntity>().subscribe((scheduleBlock) => {
      this.handleDataChange();
    });

    this.scheduleLookupParams.push(this.pilexosUser?.user?.UserId);

    if (this.formApi.formMode == DwFormContextMode.add) {
      this.setupParameters();
      this.setupBlocks();

      this.showDateSelection = true;
    } else {
      this.showDateSelection = false;
    }

    this.initComplete = true;
  }

  private handleDataChange() {

    if (!(this as any).visible) {
      return;
    }

    const scheduleBlock = this.formApi.getFormData<ScheduleBlockEntity>();

    if (scheduleBlock?._itemName == AppMetaDataItemNames.ScheduleBlockItem) {
      this.scheduleBlockItem = scheduleBlock as ScheduleBlockItemEntity;

      this.scheduleBlock = deepCopy(this.scheduleBlockItem.ScheduleBlock);
    } else {
      this.scheduleBlock = deepCopy(scheduleBlock);
    }

    this.handleAirportChange();
    this.handleSchoolChange();

    this.handleExaminerChange();

    // Runs once after data load is complete
    this.setupBlocks();

    this.checkFormSecurity();

    this.lastScheduleBlock = this.scheduleBlock;
  }

  handleExaminerChange() {
    if (!this.isSchool || !this.referenceDataLoadComplete) {
      return;
    }

    if (!this.lastScheduleBlock || this.scheduleBlock.FlightSchoolExaminerId == this.lastScheduleBlock.FlightSchoolExaminerId) {
      return;
    }

    const schoolExaminer = this.schoolExaminer.find(e => e.Id == `${this.scheduleBlock?.FlightSchoolExaminerId}`);

    if (schoolExaminer?.PilotExaminerId) {
      const blockPartial: Partial<ScheduleBlockEntity> = {
        PilotExaminerId: parseInt(schoolExaminer.PilotExaminerId)
      }

      //console.log('Updating examiner to ' + blockPartial.PilotExaminerId);

      this.updateFormData(blockPartial);

      //this.formApi.patchFormData(blockPartial);

      // Set this so examiners can be immediately validated
      this.scheduleBlock.PilotExaminerId = blockPartial.PilotExaminerId;

      this.checkFormSecurity();
    }

    // Revalidate examiner locations
    this.validateExaminerLocations();
  }


  private setupReferenceData() {

    const obs: Observable<any>[] = [];

    obs.push(this.loadPreferedAirports());

    if (this.isExaminer) {
      // Load school settings to get default color, etc.
      obs.push(
        this.examinerRepositoryService.getCurrentFlightSchoolSetup().pipe(tap((flightSchoolSetup) => {

          this.flightSchoolSetup = flightSchoolSetup;
          //this.handleSchoolChange();
        }))
      );
    }
    if (this.isSchool) {
      // Load school examiner options for security
      obs.push(
        this.scheduleBlockService.getSchoolExaminerOptions().pipe(tap((options) => {
          this.schoolExaminerOptions = options;
        }))
      );

      // Load School examiners so we can populate the pilot examiner id
      const params: DwQueryParam[] = [];
      params.push({ ParamName: 'FlightSchoolOrganizationId', ParamValue: `${this.pilexosUser.flightSchoolOrganizationId}` });

      obs.push(
        this.dwMetaDataManagerService.getLookup(AppMetaDataLookups.FlightSchoolExaminerBySchoolWithGrouping, params)
          .pipe(tap((schoolExaminers) => {
            this.schoolExaminer = schoolExaminers;
          }))
      );
    }

    combineLatest(obs).subscribe(() => {
      this.referenceDataLoadComplete = true;
      this.checkFormSecurity();
    });
  }


  checkFormSecurity() {
    if (!this.referenceDataLoadComplete || !this.scheduleBlock) {
      return;
    }

    this.isAdd = this.scheduleBlock.ScheduleBlockId ? false : true;
    let securityMessage = '';

    const previousCanEdit = this.canAddEdit;

    if (this.isAdd) {
      const canAddResult = this.scheduleBlockService.canAddBlock(this.scheduleBlock, this.schoolExaminerOptions);

      this.canAddEdit = canAddResult.canAdd;

      if (!canAddResult.canAdd) {
        // Show message with variable
        securityMessage = canAddResult.reason;
      }
    } else {
      const canEditResult = this.scheduleBlockService.canEditBlock(this.scheduleBlock, this.schoolExaminerOptions);

      this.canAddEdit = canEditResult.canEdit;
      if (!canEditResult.canEdit) {
        securityMessage = canEditResult.reason;
      }
    }

    this.canAddEditReason = securityMessage;

    if (previousCanEdit != this.canAddEdit) {
      this.validateExaminerLocations();
    }

    this.showErrorsAndWarnings();
    //this.formApi.patchVariableContext({ SecurityValidationMessage: securityMessage });
  }

  private showErrorsAndWarnings() {
    this.formApi.patchVariableContext({ SecurityValidationMessage: this.canAddEditReason, AirportErrorMessage: this.airportLocationValidationResults.errorMessage, AirportWarningMessage: this.airportLocationValidationResults.warningMessage });
  }

  private clearAirportValidations(showMessage: boolean) {
    //console.log('Clearing airport validations - showMessage: ' + showMessage);

    this.airportLocationValidationResults = {
      errors: [],
      warnings: [],
      errorMessage: '',
      warningMessage: ''
    };

    if (showMessage) {
      this.showErrorsAndWarnings();
    }
  }


  private validateExaminerLocations() {

    if (!this.scheduleBlock?.ScheduleBlockAirport || this.currentAirportDetails.length == 0) {
      return;
    }

    // If we can't add/edit, no reason to validate airports
    if (!this.canAddEdit) {
      this.clearAirportValidations(true);
      return;
    }

    //console.log('validateExaminerLocations', this.currentAirportDetails);

    this.scheduleBlockService.validateExaminerLocations(this.scheduleBlock, this.currentAirportDetails, this.schoolExaminerOptions)
      .subscribe((locationValidation) => {

        //  console.log('validateExaminerLocations - results', locationValidation);
        // Handle validation results here
        this.clearAirportValidations(false);

        if (!locationValidation.isValid || locationValidation.hasWarnings) {
          for (let airportResult of locationValidation.airportValiadtionResults) {
            if (!airportResult.isValid) {
              this.airportLocationValidationResults.errors.push(airportResult.reason);
            };
            if (airportResult.showWarning) {
              this.airportLocationValidationResults.warnings.push(airportResult.reason);
            }
          }
        }

        this.airportLocationValidationResults.warningMessage = this.airportLocationValidationResults.warnings.join(', ');
        this.airportLocationValidationResults.errorMessage = this.airportLocationValidationResults.errors.join(', ');
        this.showErrorsAndWarnings();
      });
  }


  loadPreferedAirports(): Observable<any> {
    let ob: Observable<DwLookupInfo[]>
    const params: DwQueryParam[] = [];
    switch (this.pilexosUser.UserTypeId) {
      case PilexosUserTypeIds.flightSchool:
      case PilexosUserTypeIds.checkInstructor:
        params.push({ ParamName: 'FlightSchoolOrganizationId', ParamValue: `${this.pilexosUser.flightSchoolOrganizationId}` });

        return this.dwMetaDataManagerService.getLookup(AppMetaDataLookups.AirportByFlightSchool, params).pipe(tap((airports) => {
          this.airportLookupItems = airports as any;

          this.handleAirportChange();
        }));;


      case PilexosUserTypeIds.pilotExaminer:
        params.push({ ParamName: 'PilotExaminerId', ParamValue: `${this.pilexosUser.pilotExaminerId}` });

        return this.examinerRepositoryService.getPilotExaminerAirportList()
          .pipe(map(examinerAirportList => {
            this.examinerAirportList = examinerAirportList;

            this.handleAirportChange();

            return [];
          }));
    }

    return of([]);
  }

  loadAirportDetails(airportIds: number[]): Observable<AirportWithAddressInfoQueryEntity[]> {
    let missingAirportIds = [...airportIds];

    let airportsToReturn: AirportWithAddressInfoQueryEntity[] = [];
    if (this.currentAirports.length > 0) {
      airportsToReturn = this.currentAirports.filter(a => airportIds.includes(a.AirportId));

      if (airportsToReturn.length === airportIds.length) {
        return of(airportsToReturn);
      }

      missingAirportIds = airportIds.filter(id => !airportsToReturn.some(a => a.AirportId === id));
    }

    return this.examinerRepositoryService.getAirportInfoList(missingAirportIds)
      .pipe(map(airports => {
        this.currentAirports.push(...airports);

        airportsToReturn.push(...airports);

        return airportsToReturn;
      }));
  }

  // loadMissingAirport(airportId: number): Observable<any> {
  //   // const searchParams : DwLookupSearchParams = {
  //   //   AlternateSearchField: 'AirportId',
  //   //   SearchString: `${airportId}`,
  //   //   PagingInfo: {
  //   //     PageNo:1,
  //   //     PageSize:1
  //   //   },
  //   //   SearchType: DwLookupSearchType.startsWith
  //   // };

  //   return this.dwMetaDataManagerService.getSingleLookupItem(AppMetaDataLookups.AirportWithDetail, airportId)
  //     .pipe(tap(airport => {
  //       if (airport) {
  //         this.airportLookupItems.push(airport);
  //       } else {
  //         console.log(`Airport with ID ${airportId} not found.`);
  //       }
  //     }));
  // }

  // performExaminerAirportSearch(airportIds: number[]): Observable<any> {
  //   return this.examinerRepositoryService.getExaminerAndLocationInfo(this.schoolExaminer.)
  // }

  private setupFormInterceptor() {
    const interceptor: DwFormActionInterceptor = {
      interceptorName: 'blockBookingInterceptor',
      order: 1,
      onBeforeActionWait: true,
      onBeforeAction: (actionPref: DwActionPreference<DwFormActionConfig>, actionConfig: any) => {
        return this.processBeforeAction(actionPref, actionConfig);
      },
    };

    this.dwMetaDataFormStateService.addActionInterceptor(interceptor);

  }

  protected processBeforeAction(actionPref: DwActionPreference<DwFormActionConfig>, actionConfig: any): Observable<DwFormActionInterceptResult> {
    const result: DwFormActionInterceptResult = {
      abort: false
    }

    if (!(this as any).visible) {
      return of(result);
    }

    //console.log('Block Item Type ' + this.blockItemTypeId, this.blockItemTypeId);

    const isSave = actionPref.actionKey == DwFormActionKeys.formSave;

    if (!isSave) {
      return of(result);
    }

    const validationResult = this.validateForm();

    if (!validationResult.isValid) {
      result.abort = true;
      result.message = this.dwMetaDataFormStateService.state.formApi.createValidationMessage(validationResult);

      return of(result);
    }

    return of(result);
  }

  validateForm(): DwFormValidationResult {
    const validationResult = this.dwMetaDataFormStateService.state.formApi.validateForm();

    const messageParts: string[] = [];

    const scheduleBlock = this.scheduleBlock;

    const firstAirport = scheduleBlock.ScheduleBlockAirport?.find(l => !l._isDeleted);

    if (!firstAirport || !firstAirport.AirportId) {
      messageParts.push('Aiport is required.');
    }
    scheduleBlock.ScheduleBlockItem = scheduleBlock.ScheduleBlockItem || [];

    const blockCount = scheduleBlock.ScheduleBlockItem.filter(b => !b._isDeleted)?.length || 0;

    if (this.airportLocationValidationResults?.errors?.length > 0) {
      messageParts.push(...this.airportLocationValidationResults.errors);
    }

    if (!this.hasBlocks && blockCount == 0 && this.showDateSelection) {

      // Additional custom validations can be added here
      if (this.blockItemTypeId == ScheduleBlockItemTypeAllItems.IndividualDay) {
        if (!this.selectedDates) {
          messageParts.push('Please select at least one date.');
        }
        if (!this.startTime || !this.endTime) {
          messageParts.push('Please select a start time and end time.');
        }
      }

      if (this.blockItemTypeId == ScheduleBlockItemTypeAllItems.DateRange) {
        if (!this.startDate || !this.endDate) {
          messageParts.push('Please select a date range.');
        }

        if (!this.bookingScheduleId) {
          messageParts.push('Booking Days is required.');
        }
      }
    }

    if (!this.canAddEdit && this.canAddEditReason) {
      messageParts.push(this.canAddEditReason);
    }

    if (messageParts.length > 0) {
      if (!validationResult.isValid) {

        validationResult.summaryBodyHtml = validationResult.summaryBodyHtml.replace('</ul>', `${messageParts.map(part => `<li>${part}</li>`).join('')}</ul>`);

        validationResult.summaryBodyHtml = validationResult.summaryBodyHtml.replace("error", "errors");

        //validationResult.summaryBodyHtml += `${messageParts.map(part => `<li>${part}</li>`).join('')}</ul>`;  
      } else {
        validationResult.isValid = false;
        validationResult.displayMessage = 'One or more fields are invalid.  Please correct and try again.';

        validationResult.summaryHeading = `Please fix the following error${messageParts.length > 1 ? 's' : ''}:`;
        validationResult.summaryBodyHtml = `<ul>${messageParts.map(part => `<li>${part}</li>`).join('')}</ul>`;
      }
    }

    return validationResult;
  }


  lastSchoolId: number;

  handleSchoolChange() {

    if (this.lastSchoolId == this.scheduleBlock.FlightSchoolId) {
      return;
    }

    this.lastSchoolId = this.scheduleBlock.FlightSchoolId;

    this.currentSchoolSetup = this.flightSchoolSetup?.find(s => s.FlightSchoolId == this.scheduleBlock.FlightSchoolId);

    if (!this.currentSchoolSetup?.CalendarColorName) {
      return;
    }

    const scheduleBlock = {} as Partial<ScheduleBlockEntity>;

    if (this.scheduleBlock.ColorName == this.currentSchoolSetup.CalendarColorName) {
      return;
    }

    scheduleBlock.ColorName = this.currentSchoolSetup.CalendarColorName;

    this.updateFormData(scheduleBlock);


    // // Check if we're dealing with a block item
    // if (this.scheduleBlockItem) {
    //   const scheduleBlockItem = {} as Partial<ScheduleBlockItemEntity>;
    //   scheduleBlockItem.ScheduleBlock = scheduleBlock as ScheduleBlockEntity;
    //   this.formApi.patchFormData(scheduleBlockItem);
    //   return;
    // }

    // this.formApi.patchFormData(scheduleBlock)
  }

  updateFormData(scheduleBlock: Partial<ScheduleBlockEntity>) {
    if (this.scheduleBlockItem) {
      const scheduleBlockItem = {} as Partial<ScheduleBlockItemEntity>;
      scheduleBlockItem.ScheduleBlock = scheduleBlock as ScheduleBlockEntity;
      this.formApi.patchFormData(scheduleBlockItem);
      return;
    }

    //console.log('Schedule block updated:', scheduleBlock, this.scheduleBlock);

    this.formApi.patchFormData(scheduleBlock);
  }

  lastLocationId: number;

  handleLocationChange() {
    if (!this.locations || !this.scheduleBlock) {
      return;
    }

    this.scheduleBlock.ScheduleBlockLocation = this.scheduleBlock?.ScheduleBlockLocation || [];

    const scheduleBlock = {} as Partial<ScheduleBlockEntity>;

    let blockLocation = this.scheduleBlock?.ScheduleBlockLocation?.find(l => !l._isDeleted);

    let location = this.locations.find(l => l.PilotExaminerLocationId == blockLocation?.PilotExaminerLocationId);

    if (!location) {
      location = this.determineDefaultLocation(this.locations);
      if (!location) {
        return;
      }

      if (this.formApi.formMode == DwFormContextMode.add) {
        const scheduleBlockLocation = AppMetaData.ScheduleBlockLocation.CreateEntity();
        scheduleBlockLocation.PilotExaminerLocationId = location.PilotExaminerLocationId;
        scheduleBlockLocation.ScheduleBlockId = this.scheduleBlock?.ScheduleBlockId;

        scheduleBlock.ScheduleBlockLocation = [scheduleBlockLocation];
      }
    }

    if (!location || this.lastLocationId == location.PilotExaminerLocationId) {
      return;
    }

    this.lastLocationId = location.PilotExaminerLocationId;

    scheduleBlock.BookingTimeZoneId = location?.BookingScheduleTimeZoneId;


    this.updateFormData(scheduleBlock);

    // // Check if we're dealing with a block item
    // if (this.scheduleBlockItem) {
    //   const scheduleBlockItem = {} as Partial<ScheduleBlockItemEntity>;

    //   scheduleBlockItem.ScheduleBlock = scheduleBlock as ScheduleBlockEntity;

    //   this.formApi.patchFormData(scheduleBlockItem);

    //   return;
    // }

    // this.formApi.patchFormData(scheduleBlock)
  }

  defaultAirportSet = false;

  lastAirportIds: number[];

  handleAirportChange() {
    if ((!this.airportLookupItems && !this.examinerAirportList) || !this.scheduleBlock) {
      return;
    }

    if (this.scheduleBlock?._itemName == AppMetaDataItemNames.ScheduleBlockItem) {
      // This shouldn't happen, but it is which is causing issues 
      return;
    }

    this.scheduleBlock.ScheduleBlockAirport = this.scheduleBlock?.ScheduleBlockAirport || [];

    const scheduleBlock = {} as Partial<ScheduleBlockEntity>;

    let firstBlockAirport = this.scheduleBlock?.ScheduleBlockAirport?.find(l => !l._isDeleted && l.AirportId);
    let airportIds = this.scheduleBlock?.ScheduleBlockAirport.filter(l => !l._isDeleted && l.AirportId).map(l => parseInt(l.AirportId as any));

    if (firstBlockAirport == null && !this.defaultAirportSet && this.formApi.formMode == DwFormContextMode.add) {

      this.setDefaultAirport(scheduleBlock);
      return;
    }

    // Prevent duplicate changes
    if (this.lastAirportIds && this.lastAirportIds.join(',') == airportIds.join(',')) {
      return;
    }

    this.lastAirportIds = airportIds;

    if (airportIds.length > 0) {
      this.loadAirportDetails(airportIds)
        .subscribe(airportDetails => {

          this.currentAirportDetails = airportDetails;
          this.setBlockTimezone(airportDetails, airportIds);

          this.validateExaminerLocations();
        });
    } else {
      this.clearAirportValidations(true);
    }
  }

  private setBlockTimezone(airportDetails: AirportWithAddressInfoQueryEntity[], airportIds: number[]) {
    const airport = airportDetails.find(a => a.AirportId == airportIds[0]);

    if (!airport || this.lastAirportId == airport.AirportId) {
      return;
    }

    this.lastAirportId = airport.AirportId;

    const scheduleBlock: Partial<ScheduleBlockEntity> = {};

    if (!airport.AirportAddressTimezoneId) {
      return;
    }

    if (this.scheduleBlock.BookingTimeZoneId == airport.AirportAddressTimezoneId) {
      return;
    }

    // Update timezone
    scheduleBlock.BookingTimeZoneId = airport.AirportAddressTimezoneId;

    this.updateFormData(scheduleBlock);
    // // Check if we're dealing with a block item
    // if (this.scheduleBlockItem) {
    //   const scheduleBlockItem = {} as Partial<ScheduleBlockItemEntity>;

    //   scheduleBlockItem.ScheduleBlock = scheduleBlock as ScheduleBlockEntity;

    //   this.formApi.patchFormData(scheduleBlockItem);

    //   return;
    // }

    // this.formApi.patchFormData(scheduleBlock)
  }


  setDefaultAirport(scheduleBlock: Partial<ScheduleBlockEntity>) {
    let airportId = this.determineDefaultAirportId();

    if (this.defaultAirportSet) {
      return;
    }

    this.defaultAirportSet = true;

    if (!airportId) {
      return;
    }

    if (this.formApi.formMode == DwFormContextMode.add) {

      const scheduleBlockAirport = AppMetaData.ScheduleBlockAirport.CreateEntity();

      scheduleBlockAirport.AirportId = airportId;
      scheduleBlockAirport.ScheduleBlockId = this.scheduleBlock?.ScheduleBlockId;

      scheduleBlock.ScheduleBlockAirport = [scheduleBlockAirport];

      this.updateFormData(scheduleBlock);
    }

    return airportId;
  }

  determineDefaultAirportId(): number {

    if (this.examinerAirportList == null) {
      const airport = this.airportLookupItems?.find(a => true); // Need better logic than just the first one

      if (airport) {
        return parseInt(airport.Id);
      }

      return null;
    }

    const airport = this.examinerAirportList.find(a => a.RoPilotExaminerLocationCurrentPilotExaminerLocationStateId == 1);

    return airport?.AirportAirportId;
  }


  currentBlockDates: ScheduleBlockDateRef[] = [];


  blocksSetup = false;

  private setupBlocks() {
    if (!this.formApi.isDataLoadComplete) {
      return;
    }
    if (this.blocksSetup) {
      return;
    }

    this.blocksSetup = true;

    this.currentBlockDates = this.scheduleBlockService.getCurrentBlockDates() || [];

    if (this.currentBlockDates.length > 0) {
      this.buildScheduleBlocksFromCurrentBlockDates();

      this.hasBlocks = true;
      return;
    }

    const addContext = (this.formApi as any).addContext;  // TODO: remove after DwMetaDataFormApi  updated

    if (!addContext) {
      return;
    }

    const blockItem: ScheduleBlockItemEntity = addContext;

    this.startDate = blockItem.StartDate;;
    this.endDate = blockItem.EndDate;

    this.startTime = blockItem.StartTime;
    this.endTime = blockItem.EndTime;

    this.selectedDates = this.startDate;
  }

  buildScheduleBlocksFromCurrentBlockDates() {
    const blockItems: ScheduleBlockItemEntity[] = [];

    for (const blockDate of this.currentBlockDates) {
      const block: ScheduleBlockItemEntity = AppMetaData.ScheduleBlockItem.CreateEntity();

      block.ScheduleBlockItemStatusId = ScheduleBlockItemStatusAllItems.Active;

      block.ScheduleBlockItemTypeId = this.blockItemTypeId;
      block.StartDate = blockDate.startDate;
      block.EndDate = blockDate.endDate;

      block.StartTime = blockDate.startTime;
      block.EndTime = blockDate.endTime;

      blockItems.push(block);
    }

    const scheduleBlockUpdate: Partial<ScheduleBlockEntity> = {};
    scheduleBlockUpdate.ScheduleBlockItem = blockItems;

    if (this.scheduleBlockItem) {
      console.warn('Can update schedule blocks since ScheduleBlockItem is the root item');
      return;
    }

    this.formApi.patchContextData(DwMdFormContextInfo.DATA_CONTEXT_NAME, scheduleBlockUpdate);
    this.formApi.formGroup.patchValue(scheduleBlockUpdate);
    this.formApi.patchFormData(scheduleBlockUpdate);
  }

  setupParameters() {
    const start = getParameterByName(this.router, 'start');
    const end = getParameterByName(this.router, 'end');

    if (!start && !end) {
      return;
    }

    const dateRef = this.scheduleBlockService.parseBlockStartEndDates(start, end);

    this.startDate = dateRef.startDate;
    this.endDate = dateRef.endDate;

    this.startTime = dateRef.startTime
    this.endTime = dateRef.endTime;

    this.selectedDates = this.startDate;
  }

  onDataChange() {
    this.buildScheduleBlockingItems();
  }

  previousBlockItems: ScheduleBlockItemEntity[];

  buildScheduleBlockingItems() {
    const scheduleBlockUpdate: Partial<ScheduleBlockEntity> = {};

    switch (this.blockItemTypeId) {
      case ScheduleBlockItemTypeAllItems.IndividualDay:
        scheduleBlockUpdate.ScheduleBlockItem = this.buildIndividaulDayBlockItems();
        break;
      case ScheduleBlockItemTypeAllItems.DateRange:
        scheduleBlockUpdate.ScheduleBlockItem = this.buildDateRangeBlockItems();
        break;
    }

    if (areEqual(this.previousBlockItems, scheduleBlockUpdate.ScheduleBlockItem)) {
      return;
    }

    this.previousBlockItems = scheduleBlockUpdate.ScheduleBlockItem;


    if (this.scheduleBlockItem) {
      console.warn('Can update schedule blocks since ScheduleBlockItem is the root item');
      return;
    }

    this.formApi.patchContextData(DwMdFormContextInfo.DATA_CONTEXT_NAME, scheduleBlockUpdate);
    this.formApi.formGroup.patchValue(scheduleBlockUpdate);
    this.formApi.patchFormData(scheduleBlockUpdate);
  }

  buildDateRangeBlockItems(): ScheduleBlockItemEntity[] {
    const blockItems: ScheduleBlockItemEntity[] = [];

    if (!this.startDate || !this.endDate) {
      return [];
    }

    const block: ScheduleBlockItemEntity = AppMetaData.ScheduleBlockItem.CreateEntity();

    block.ScheduleBlockItemStatusId = ScheduleBlockItemStatusAllItems.Active;
    block.ScheduleBlockItemTypeId = ScheduleBlockItemTypeAllItems.DateRange;

    block.ScheduleBlockItemTypeId = this.blockItemTypeId;
    block.StartDate = this.startDate;;
    block.EndDate = this.endDate;

    block.BookingScheduleId = this.bookingScheduleId;

    // block.StartTime = this.startTime;
    // block.EndTime = this.endTime;

    blockItems.push(block);

    return blockItems;
  }

  buildIndividaulDayBlockItems(): ScheduleBlockItemEntity[] {
    const blockItems: ScheduleBlockItemEntity[] = [];

    if (!this.selectedDates) {
      return [];
    }

    const selectedDates = this.selectedDates.split(',');

    for (const dateString of selectedDates) {
      const block: ScheduleBlockItemEntity = AppMetaData.ScheduleBlockItem.CreateEntity();

      block.ScheduleBlockItemStatusId = ScheduleBlockItemStatusAllItems.Active;
      block.ScheduleBlockItemTypeId = ScheduleBlockItemTypeAllItems.IndividualDay;

      block.ScheduleBlockItemTypeId = this.blockItemTypeId;
      block.StartDate = dateString;
      block.EndDate = dateString;

      block.StartTime = this.startTime;
      block.EndTime = this.endTime;

      blockItems.push(block);
    }

    return blockItems;
  }

  private determineDefaultLocation(locations: PilotExaminerLocationEntity[]): PilotExaminerLocationEntity {
    for (const location of locations) {
      if (location.PilotExaminerLocationTypeId == PilotExaminerLocationTypeAllItems.Home && location.IsActive) {
        return location;
      }
    }

    return null;
  }
}

